<template>
	<qrcode-vue
		:id="`qr-code-${value}`"
		:value="value"
		:size="size"
		:margin="margin"
		level="H"
	/>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'
import QrcodeVue from 'qrcode.vue'

defineProps({
	value: {
		type: String,
		required: true,
	},
	size: {
		type: Number,
		required: true,
	},
	margin: {
		type: Number,
		required: true,
	},
})
</script>
